export default __webpack_public_path__ + "static/stiletto-5bf068ac7a736f0788df7fe68873e8e0.png";